import { useState } from "react";
import useFacility from "../../../../../utils/hooks/useFacility";
import { post } from "../../../../api";
import { CANCLE_CURRENT_EXERCISE } from "../../../../api/apiRoutes";


export default function useFutureTickets() {
  const facilityIds = useFacility();
  const [alert, setAlert] = useState("");
  const resignFromExercise = async (exerciseIds: number) => {
    const { result, isError, errorTable } = await post(CANCLE_CURRENT_EXERCISE(`0,` + exerciseIds, facilityIds));
    if (isError) {
      setAlert(errorTable[0]);
    }
  }

  return {
alert,
    resignFromExercise,
  };
}


